import NewWorker from "../../../../components/@users/workers/NewWorker";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function WorkerNewPage() {

    return (
        <NewWorker 
            routeType={routeTypes.admin}
        />
    )
}       